import React, { useState, useEffect } from "react"
import { getAgevolazioni, getDettagliVeicoloAttivo } from "../../services/endpoints";
import { showProgress, moveFocusTo } from "../../utils/elements";
import {
  Container,
  Row,
  Col,
  Button
} from 'design-react-kit';

export const SibaMostraDettagliVeicolo = ({ veicolo, handleBack }) => {

  const [dettagliVeicolo, setDettagliVeicolo] = useState({});
  const [isLoading, setLoading] = useState(true);
  const [agevolazioni, setAgevolazioni] = useState([]);

  useEffect(() => {
    async function fetchData() {
      const responseDettagliVeicolo = await getDettagliVeicoloAttivo(veicolo.idVeicolo)
      console.log("responseDettagliVeicolo", responseDettagliVeicolo)
      if (responseDettagliVeicolo === undefined) {
        console.log('Veicolo con id %s non trovato', veicolo.idVeicolo)
        setLoading(false)
        return
      }

      const ricercaAgevolazioni = {
        "idVeicolo": veicolo.idVeicolo,
        "idProprietario": veicolo.idProprietario
      }

      const responseDatiAgevolazioni = await getAgevolazioni(ricercaAgevolazioni)
      if (responseDatiAgevolazioni !== undefined) {
        let agevolazioniDaVisualizzare = [];
        if (responseDatiAgevolazioni.status === undefined && responseDatiAgevolazioni.length > 0) {
          responseDatiAgevolazioni.forEach(element => {
            let agevolazione = {}
            agevolazione.dataInizio = element.dataInizio;
            agevolazione.dataFine = element.dataFine;
            agevolazione.descrizione = element.descrizione;
            agevolazioniDaVisualizzare.push(agevolazione);
          });
        }
        console.log(agevolazioniDaVisualizzare)
        setAgevolazioni(agevolazioniDaVisualizzare)
      }
      
      setDettagliVeicolo(responseDettagliVeicolo)
      setLoading(false)
    }

    fetchData();
  }, []);

  useEffect(() => {
    moveFocusTo("chiudi_dettaglio");
  });

  const readAgevolazioni = () => {
    return (agevolazioni.length > 0 ? (
      <Container className="px-2 my-2" id="dettagliVeicoli" tag="section">
        <table className="table table-striped table-sm">
          <thead className="thead-light">
            <tr>
              <th className="align-middle text-center">Note</th>
              <th className="align-middle text-center">Inizio</th>
              <th className="align-middle text-center">Fine</th>
            </tr>
          </thead>
          <tbody>
            {agevolazioni.map((element, i) => (
              <tr key={i}>
                <td className="align-middle text-center">{element.descrizione}</td>
                <td className="align-middle text-center">{element.dataInizio}</td>
                <td className="align-middle text-center">{element.dataFine}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <hr />
      </Container>) : React.Fragment
    )
  }

  //START RENDERING
  if (isLoading) { return showProgress() }

  return (
    <Container className="px-2 my-2" id="dettagliVeicolo1" tag="section">
      {readAgevolazioni()}
      <Container className="px-2 my-2" id="dettagliVeicolo2" tag="section">
        <Row>
          <Col>
            <h3>Dettagli veicolo</h3>
            <table className="table table-striped table-sm" id="vertical-1">
              <tbody>
                <tr>
                  <th>Targa</th>
                  <td>{veicolo.targa}</td>
                </tr>
                <tr>
                  <th>Tipo</th>
                  <td>{veicolo.tipoVeicolo}</td>
                </tr>
                <tr>
                  <th>Categoria Euro</th>
                  <td>{dettagliVeicolo.categoriaEuro}</td>
                </tr>
                <tr>
                  <th>Cilindrata</th>
                  <td>{dettagliVeicolo.cilindrata}</td>
                </tr>
                <tr>
                  <th>Alimentazione</th>
                  <td>{dettagliVeicolo.alimentazione}</td>
                </tr>
                <tr>
                  <th>Data Immatricolazione</th>
                  <td>{dettagliVeicolo.dataImmatricolazione}</td>
                </tr>
                <tr>
                  <th>Data inizio propriet&agrave;</th>
                  <td>{veicolo.dataInizioProprieta}</td>
                </tr>
              </tbody>
            </table>
          </Col>
        </Row>
        <Button id="chiudi_dettaglio" className="btn btn-primary" size="xs" color="primary" icon={false} tag="button" onClick={handleBack} >
          Chiudi dettaglio
        </Button>
      </Container>
    </Container>
  )
}

export default SibaMostraDettagliVeicolo;